<script setup lang="ts">
import SearchSelect from "../ui/form/SearchSelect.vue";
import TextInput from "../ui/form/TextInput.vue";
//import CheckInput from "../ui/form/CheckInput.vue";
//import TextAreaInput from "../ui/form/TextAreaInput.vue";
//import NumberInput from "../ui/form/NumberInput.vue";
import { ref, onMounted } from "vue";
import ModalFormTemplate from "../../components/ui/Templates/ModalFormTemplate.vue";
//import { useFormValidation } from "../../composables/useFormValidation";
//import { required } from "../../utils/validation";
import {
  Filter,
} from "../../types/report";
//import {  mapSqlTypeToVueType } from "../../types/mapSqlTypeToVueType";
import Buttons from "../ui/form/Buttons.vue";
import { api } from "../../api/Api";

const props = defineProps<{
  filters: Filter[];
  title: string;  
}>();

const emit = defineEmits<{
  (e: "filter", filters: Filter[]): void;
  (e: "close"): void;
}>();

const handleSubmit = async () => {
  emit("filter", props.filters);
};

const filterOptions = ref<Record<number, Array<{ id: string | number | null; name: string }>>>({});

const loadOptions = async (filter: Filter, idx: number) => {
  console.log("Loading options for filter:", filter, "at index:", idx);
  if (filter.matchType === "DB Field") {
    const list = await getOptions(filter);
    filterOptions.value[idx] = list || [];
  }
};
const getOptions = async (filter: Filter) => {
  if (filter.matchType === "DB Field") {
    const response = await api.post("/clients/reports/list-data", {
      table: filter.dbTableAlias,
      id_field: filter.dbIdField,
      name_field: filter.dbNameField,
    });
    if (response.success === true) {
      return response.data;
    } else {
      return [];
    }
  }
};

//const isReadOnly = ref(true);
onMounted(() => {
  props.filters.forEach((_filter, idx) => {
    filterOptions.value[idx] = [];
  });
  console.log("ReportFilter mounted with filters:", filterOptions.value);
  props.filters.forEach((filter, idx) => {
    console.log("Processing filter:", filter, "at index:", idx);
    if (filter.matchType === "DB Field") {
      console.log("Loading options for filter:", filter, "at index:", idx);
      loadOptions(filter, idx);
    }
  });
});
</script>
<template>
  <ModalFormTemplate
    :data="null"
    :mode="'view'"
    :title="title || 'Filter Report'"
    endPoint=""
    :perm="[]"
    :tabList="[]"
    :formData="{}"
    @save="handleSubmit"
    @close="$emit('close')"
  >
  <template #header>
    <Buttons caption="Filter" icon="filter" @click="handleSubmit" />
  </template>
  <template #form>
    <div class="grid md:grid-cols-4 gap-6">
        <template v-for="(filter, idx) in props.filters">
            <TextInput
                v-model="filter.value"
                :label="filter.caption + (filter.required ? ' *' : '')"
                v-if="filter.matchType == 'Value'"
                :error="filter.error"
            />
            <SearchSelect
                :label="filter.caption + (filter.required ? ' *' : '')"
                v-model="filter.value"
                v-if="filter.matchType == 'DB Field'"
                :error="filter.error"
                :options="filterOptions[idx] || []"
            />
        </template>
      </div>
        </template>
  </ModalFormTemplate>
</template>
